module.exports = __webpack_public_path__ + "static/media/When-in-Aruba-leaf-1-2.2d0cc146.svg";